export interface ICalculatorTheme {
  id: string;
  name: string;
  styling: {
    container: string;
    inputSection: string;
    outputSection: string;
    boxShadow: string;
    outputBoxShadow?: string;
  };
  behavior: {
    bottomMargin: boolean;
    labelClass?: string;
    showAccordion: boolean;
    includeOutputInFormData: boolean;
    showConditionalSpacing?: boolean;
  };
}

export const CALCULATOR_THEMES: Record<string, ICalculatorTheme> = {
  default: {
    id: 'default',
    name: 'Default Calculator Theme',
    styling: {
      container: 'flex items-start w-full sm:flex-col sm:gap-9',
      inputSection: 'bg-white p-12 sm:p-6 rounded-tl-md rounded-br-md',
      outputSection: 'bg-white p-12 sm:p-6 xs:p-2 rounded-tr-md',
      boxShadow: '0px 0px 30px 0px #1369EB1A',
    },
    behavior: {
      bottomMargin: true,
      showAccordion: true,
      includeOutputInFormData: false,
      showConditionalSpacing: false,
    },
  },
  gst: {
    id: 'gst',
    name: 'GST Calculator Theme',
    styling: {
      container: 'flex items-center w-full sm:flex-col sm:gap-9',
      inputSection: 'bg-white p-6 rounded-lg',
      outputSection: 'bg-white p-6 rounded-lg border-2 border-blue-300',
      boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.1)',
      outputBoxShadow: '0 0 30px 0 rgba(19, 105, 235, 0.10)',
    },
    behavior: {
      bottomMargin: false,
      labelClass: 'font-semibold',
      showAccordion: false,
      includeOutputInFormData: true,
      showConditionalSpacing: true,
    },
  },
};
